const calculateAvailableLabelWidth = (formContainer, breakpoint) => {
  if (formContainer.children[0]) {
    const formStyles = getComputedStyle(formContainer.children[0]);
    const columnGapSize = parseFloat(
      formStyles.getPropertyValue("--rx-prescription-column-gap").trim()
    );
    const screenSize = breakpoint.toString().toLowerCase().split("_")[0];
    const columnMinWidth = parseFloat(
      formStyles.getPropertyValue(`--rx-prescription-column-min-width-${screenSize}`).trim()
    );
    const columnGaps = columnGapSize * 2;
    const wrapperWidth = formContainer.clientWidth - columnGaps;
    const col2and3Width = Math.max(columnMinWidth, wrapperWidth * (1 / 3)) * 2;
    const col1Width = wrapperWidth - col2and3Width;
    return col1Width;
  } else {
    return 0;
  }
};
export {
  calculateAvailableLabelWidth
};
//# sourceMappingURL=calculate-available-label-width.js.map
